/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/label-has-for */
import _ from 'underscore';
import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Checkbox } from '@bingads-webui-react/checkbox';
import { Alert } from '@bingads-webui-react/alert';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { DisclaimerEditor } from './disclaimer-editor';
import { DisclaimerSelector } from './disclaimer-selector';

export { DisclaimerStringMap } from './i18n/disclaimer-string-map';

Modal.setAppElement(document.body);

const defaultSelectedDisclaimer = () => ({ Id: 0 });

export class AdsCampaignDisclaimers extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    campaignId: PropTypes.number,
    DisclaimerAdsEnabled: PropTypes.bool,
    AllowDisclaimerEnabled: PropTypes.bool,
    selectedDisclaimer: PropTypes.shape({
      Id: PropTypes.number,
    }),
    resetSelectedDisclaimer: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    schema: PropTypes.object.isRequired,
    repository: PropTypes.shape({
      extension: PropTypes.shape({
        create: PropTypes.func.isRequired,
        destroy: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
    usePanel: PropTypes.bool,
    isDisclaimerCheckboxDisabled: PropTypes.bool,
    onDisclaimerCheckboxChange: PropTypes.func,
    onDataChange: PropTypes.func,
    isForNew: PropTypes.bool,
    isNativeAd: PropTypes.bool,
    disableTitle: PropTypes.bool,
    enableRandomPage: PropTypes.bool,
    showOnlyPopupLayout: PropTypes.bool,
    perfMarker: PropTypes.shape({
      willInit: PropTypes.func,
      done: PropTypes.func,
    }),
  };

  static defaultProps = {
    campaignId: 0,
    enableRandomPage: true,
    DisclaimerAdsEnabled: false,
    AllowDisclaimerEnabled: false,
    selectedDisclaimer: defaultSelectedDisclaimer(),
    resetSelectedDisclaimer: _.noop,
    usePanel: false,
    isDisclaimerCheckboxDisabled: false,
    onDisclaimerCheckboxChange: _.noop,
    onDataChange: _.noop,
    isForNew: false,
    isNativeAd: false,
    disableTitle: false,
    showOnlyPopupLayout: false,
    perfMarker: null,
  };

  constructor(props) {
    super(props);
    const selectedDisclaimerInfo = this.props.DisclaimerAdsEnabled && _.result(this.props.selectedDisclaimer, 'Id', 0) ?
      this.props.selectedDisclaimer : defaultSelectedDisclaimer();
    // the disclaimer uncheck by default
    this.state = {
      isCheckboxFocusStyle: false,
      enableDisclaimer: this.props.DisclaimerAdsEnabled,
      isAddOpen: false,
      selectedDisclaimer: selectedDisclaimerInfo,
      errorMessage: [],
      toggleSinceUpdated: true,
      EditingDisclaimer: null,
    };

    // only for test purpose
    if (this.props.testRef) {
      this.props.testRef.current = {
        getValues: this.getValues.bind(this),
        state: this.state,
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.DisclaimerAdsEnabled !== prevProps.DisclaimerAdsEnabled) {
      this.props.onDisclaimerCheckboxChange(this.props.DisclaimerAdsEnabled);
      const errorMeassageClearIfNeeded = this.props.isForNew ? {} : { errorMessage: [] };
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        enableDisclaimer: this.props.DisclaimerAdsEnabled,
        isAddOpen: false,
        selectedDisclaimer: this.props.DisclaimerAdsEnabled && _.result(this.props.selectedDisclaimer, 'Id', 0) ?
          this.props.selectedDisclaimer : defaultSelectedDisclaimer(),
        EditingDisclaimer: null,
        ...errorMeassageClearIfNeeded,
      });
    }

    if (this.props.isForNew &&
      this.props.DisclaimerAdsEnabled && _.result(this.props.selectedDisclaimer, 'Id', 0)
      && _.get(this.props.selectedDisclaimer, 'Id', 0) !== _.get(prevProps.selectedDisclaimer, 'Id', 0)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        selectedDisclaimer: this.props.selectedDisclaimer,
      });
    }

    if (this.props.isForNew &&
      (this.state.enableDisclaimer !== prevState.enableDisclaimer || _.get(prevState, ['selectedDisclaimer', 'Id'], 0) !== _.get(this.state, ['selectedDisclaimer', 'Id'], 0))
    ) {
      this.props.onDataChange();
    }
  }

  onCheckedChange = ({ isTrusted }) => {
    this.setState((prev) => {
      const newValue = !prev.enableDisclaimer;
      this.props.onDisclaimerCheckboxChange(newValue);
      return {
        enableDisclaimer: newValue,
        errorMessage: [],
        isCheckboxFocusStyle: newValue && isTrusted === false,
      };
    });
  };

  onDisclaimerAddOrUpdated = (updatedExtension = null) => {
    if (updatedExtension && updatedExtension.Id > 0 &&
      updatedExtension.Id === this.state.selectedDisclaimer.Id) {
      this.setState(prev => ({
        selectedDisclaimer: updatedExtension,
        toggleSinceUpdated: !prev.toggleSinceUpdated,
      }));
    } else {
      this.setState(prev => ({
        toggleSinceUpdated: !prev.toggleSinceUpdated,
      }));
    }
  };

  onAddClick = (e) => {
    e.preventDefault();
    this.setState({
      isAddOpen: true,
    });
  };

  onEditUIClose = () => {
    this.setState({
      isAddOpen: false,
      EditingDisclaimer: null,
    });
  };

  onSelectDisclaimer = (selectedItem) => {
    this.setState({
      selectedDisclaimer: selectedItem,
      errorMessage: [],
    });
  };

  onEdit = (extension) => {
    this.setState({
      EditingDisclaimer: extension,
      isAddOpen: true,
    });
  };

  onRemove = (extension) => {
    if (extension.Id === this.state.selectedDisclaimer.Id) {
      this.setState({
        selectedDisclaimer: defaultSelectedDisclaimer(),
      });
    }
    if (extension.Id === _.result(this.props.selectedDisclaimer, 'Id', 0)) {
      this.props.resetSelectedDisclaimer();
    }
    this.onDisclaimerAddOrUpdated();
  };

  getValues = (campaignName) => {
    const result = {};
    // We need to update the value anyway even if the data is illegal in the display plus campaign
    if (this.props.isForNew || this.validate()) {
      result.DisclaimerAdsEnabled = this.state.enableDisclaimer;

      const campaignInfo = this.props.campaignId > 0 ? {
        Campaign: {
          Id: this.props.campaignId,
        },
      } : {
        CampaignName: campaignName,
      };
      if (this.state.enableDisclaimer) {
        if (!this.props.selectedDisclaimer ||
          this.props.selectedDisclaimer.Id !== this.state.selectedDisclaimer.Id) {
          result.AdExtensionAssociations = [_.defaults({
            Id: this.state.selectedDisclaimer.Id,
            Name: this.state.selectedDisclaimer.Name,
            Type: 'CampaignDisclaimerAdExtension',
            Status: 'Active',
          }, campaignInfo)];
          if (_.result(this.props.selectedDisclaimer, 'Id', 0)) {
            result.AdExtensionAssociations = result.AdExtensionAssociations.concat(_.defaults({
              Id: this.props.selectedDisclaimer.Id,
              Type: 'CampaignDisclaimerAdExtension',
              Status: 'Deleted',
            }, campaignInfo));
          }
        }
      }
      if (!this.state.enableDisclaimer && this.props.selectedDisclaimer && this.props.selectedDisclaimer.Id) {
        result.AdExtensionAssociations = [_.defaults({
          Id: this.props.selectedDisclaimer.Id,
          Type: 'CampaignDisclaimerAdExtension',
          Status: 'Deleted',
        }, campaignInfo)];
      }
    }
    return result;
  };

  validate = () => {
    const valid = !this.state.enableDisclaimer || (
      this.state.selectedDisclaimer
      && this.state.selectedDisclaimer.Id > 0);
    this.setState({
      errorMessage: valid ?
        [] : [this.props.i18n.getString('Validation_NotEmpty_Required_Field')],
    });
    return valid;
  };

  validateAndWarn = () => {
    const valid = this.validate();
    return valid ? null : this.props.i18n.getString('Disclaimers_Should_Check_With_Selected_Disclaimer');
  };

  render() {
    const disclaimerEditor = (
      <DisclaimerEditor
        editData={this.state.EditingDisclaimer}
        onClose={this.onEditUIClose}
        onDisclaimerAddOrUpdated={this.onDisclaimerAddOrUpdated}
        repository={this.props.repository.extension}
        usePanel={this.props.usePanel}
        isNativeAd={this.props.isNativeAd}
        showOnlyPopupLayout={this.props.showOnlyPopupLayout}
        perfMarker={this.props.perfMarker}
        {..._.pick(this.props, 'i18n', 'schema', 'permissions')}
      />
    );

    const addContent = (
      <React.Fragment>
        <div className="form-control-static">
          <a
            href="#"
            className="addDisclaimerButton"
            onClick={this.onAddClick}
            role="button"
          >
            {this.props.i18n.getString('Disclaimers_Add')}
          </a>
        </div>
        {this.props.usePanel ?
          <Panel
            isOpen={this.state.isAddOpen}
            onClose={this.onEditUIClose}
            panelClassName="disclaimer-editor-panel"
            title={this.props.i18n.getString(this.state.EditingDisclaimer ? 'Disclaimers_Edit' : 'Disclaimers_Create')}
            i18n={this.props.i18n}
            panelReadyAriaLabel={this.props.i18n.getString('Disclaimer editor side panel opened')}
          >
            {disclaimerEditor}
          </Panel> :
          <Modal
            isOpen={this.state.isAddOpen}
            onRequestClose={this.onEditUIClose}
            shouldCloseOnOverlayClick={false}
            overlayClassName="disclaimer-editor-overlay react-modal-overlay"
            className="disclaimer-editor-modal react-modal"
          >
            {disclaimerEditor}
          </Modal>
        }
      </React.Fragment>);

    const selectorContent = (
      <DisclaimerSelector
        i18n={this.props.i18n}
        selectedDisclaimer={this.state.selectedDisclaimer}
        toggleSinceUpdated={this.state.toggleSinceUpdated}
        repository={this.props.repository.extension}
        onSelectDisclaimer={this.onSelectDisclaimer}
        onEdit={this.onEdit}
        onRemove={this.onRemove}
        shouldFilterPopup={this.props.isNativeAd || this.props.showOnlyPopupLayout}
        enableRandomPage={this.props.enableRandomPage}
      />
    );

    const errorsContent = this.state.errorMessage && this.state.errorMessage.length > 0 &&
      (<ErrorMessages messages={this.state.errorMessage} className="disclaimer-setting error" />);
    // todo search campaign only
    return (this.props.campaignId === 0 ||
      (this.props.campaignId > 0)) && (
        <div className="form-group" data-testid="AdsCampaignDisclaimers">
          {
          !this.props.isForNew && !this.props.disableTitle && (
            <div className="col-sm-2 control-label">
              <label>
                {this.props.i18n.getString('DisclaimerLabelText')}
                <HelpPopup
                  topic="pop_BA_DisclaimerAd"
                  aria-label={`${this.props.i18n.getString('LearnMoreLinkText')} ${this.props.i18n.getString('DisclaimerLabelText')}`}
                />
              </label>
            </div>
          )
          }
          <div className="col-sm-8">
            {(this.props.campaignId > 0 && !this.props.AllowDisclaimerEnabled) ?
              <React.Fragment>
                <div className="form-control-static disclaimer-description">
                  {this.props.isNativeAd ?
                  this.props.i18n.getString('Disclaimers_Native_Campaign_Description')
                  : this.props.i18n.getString('Disclaimers_Campiagn_Description')}
                </div>
                {selectorContent}
                {errorsContent}
                {addContent}
              </React.Fragment> :
              <React.Fragment>
                <Checkbox
                  // disabled={this.props.isDisclaimerCheckboxDisabled}
                  className={this.state.isCheckboxFocusStyle && 'focus-style'}
                  checked={this.state.enableDisclaimer}
                  name="show-checkbox"
                  onChange={this.onCheckedChange}
                  id="disclaimer-setting-checkbox"
                >
                  {this.props.isNativeAd ?
                  this.props.i18n.getString('Disclaimers_Native_Campaign_Description')
                  : this.props.i18n.getString('Disclaimers_Campiagn_Description')}
                </Checkbox>
                <div className="checkbox">
                  {this.state.enableDisclaimer &&
                    <React.Fragment>
                      <Alert
                        level="Info"
                        dismissible={false}
                        icon={(<div className="alert-image" />)}
                        message={this.props.AllowDisclaimerEnabled ? this.props.i18n.getString('Disclaimers_Campaign_Hint_New') : this.props.i18n.getString('Disclaimers_Campaign_Hint')}
                      />
                      {selectorContent}
                      {errorsContent}
                      {addContent}
                    </React.Fragment>}
                </div>
              </React.Fragment>
            }
          </div>
        </div>);
  }
}

